var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFamily(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E36414;}\n\t.st1{fill:#B24E10;}\n\t.st2{fill:#EF917B;}\n\t.st3{fill:#E96B4E;}\n\t.st4{fill:#F7C9AB;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#E96B4E;}\n\t.st6{fill:#EBEAE0;}\n\t.st7{fill:#F5F4EF;}\n\t.st8{fill:#DB3429;}\n\t.st9{fill:#D7D5C1;}\n\t.st10{fill:#F3AB7D;}\n\t.st11{fill:#B3271E;}\n\t.st12{fill:#57130F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3896_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M486,295c0,0,21-18.9,21-67.4c0-48.5-41.5-93.6-46.7-133.2C455.3,56.1,439.7,5,358.5,5    C283.4,5,270,70.4,270,107.2c0,36.8,12,74.8,15,98.8v89H486L486,295z",
    id: "XMLID_4097_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.3,102.5c1.7,19-12.8,43.2-7.3,59.9c5.5,16.6,23.1,56.5-6,82.8    c-29,26.3-87,28-108.5-6.8C299,203.6,287,107.2,287,107.2L442.3,102.5L442.3,102.5z",
    id: "XMLID_4096_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M305,404.1l-3.5-33l24.8-136.4c10.4-2,20.5-9.1,24.3-18.8l-3.7-26.6l43.1-11.3l3.6,32.4    c30.4,26.5,58.2,11,78.3,34.6c28,32.9,7,131.9,0,176.9s14.2,85,14.2,85H327L305,404.1L305,404.1z",
    id: "XMLID_4095_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M472,422c7-45,28-144,0-176.9c0,32.4-79,192.5-40.3,261.9h54.5C486.1,507,465,467,472,422",
    id: "XMLID_4094_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M413.2,222.7c-1.9,2.8-37.2,53.2-48.5,89.4c0,0-25-22.9-31.7-50.2l-6.7-27.2    c10.4-2,20.5-9.1,24.4-18.8l-3.7-26.6l43.1-11.3l3.6,32.4C400.3,216.3,406.8,220.1,413.2,222.7",
    id: "XMLID_4093_"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    id: "XMLID_4092_",
    points: "194,469 38,469 38,507 194,507 194,469   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M177.2,181.4l-4.8,30.6l14.4,17.7L256,270v199H38v38H5c0,0,1.7-203.5,17.2-241    c11.8-28.4,71.2-41.4,71.2-41.4l25-14l5.4-35.5L177.2,181.4L177.2,181.4z",
    id: "XMLID_4091_"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    id: "XMLID_4090_",
    points: "186.8,229.7 172.4,212 137,234.8 118.4,210.5 93.4,224.5 113,254.5 137,234.8     150.5,260 173.4,245.1 186.8,229.7   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M329,310l4-48.2c0,0,8.5-13.4,6.6-18.9c-1.9-5.5-20.4-10.5-20.4-10.5s8.8-17.4,1.3-22.4    c-7.5-5-25,9.5-25,9.5s-16.1-24-22.1-20c-6,4-11.4,21.5-11.4,21.5s-49.2-22-49.2-10.5c0,11.8,5.2,21.5,5.2,21.5s-46.2-7.5-46.2,4    c0,11,9.2,24.3,9.2,24.3l2,49.7H329L329,310z",
    id: "XMLID_4089_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M182,474H38c-1.8,0-3.4-1-4.3-2.5l-12-20.8c-0.9-1.6-0.9-3.6,0.1-5.1l9.4-15.1l14-138.3    l9.9,1L41.1,432.6c-0.1,0.8-0.3,1.5-0.7,2.1l-8.5,13.5l9,15.7H182V474L182,474z",
    id: "XMLID_4088_"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    id: "XMLID_4087_",
    points: "177.2,181.4 172.4,212 137,234.8 118.4,210.5 123.8,175 177.2,181.4   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M225,107.2c0,0,11.4-19.1,22.1-39.5c13.1-24.8-24.4-52.3-45.6-57.3    c-21.2-5-36.1,6.3-36.1,6.3S153.8,5,128.1,5C102.4,5,79.6,23.2,79,48.2C78.5,67.2,93.4,94,93.4,94l64.6,44.5L225,107.2L225,107.2z    ",
    id: "XMLID_4086_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M242.8,127c-5.4,9.5-17.9,13.9-28.6,10.2l10.9-30c0,0,5.9-6.2,15.3-4.4    C249.8,104.6,248.2,117.6,242.8,127",
    id: "XMLID_4085_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M96,123.1c-12.3,2.7-20.6-3.8-25.4-15.9c-4.8-12-0.9-19.8,8.7-21    c9.6-1.2,14.1,7.8,14.1,7.8L96,123.1L96,123.1z",
    id: "XMLID_4084_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M225,107.2l-23.4,64.6l-37.9,14.9l-28.9-3.2l-35.8-26.8L93.4,94c30.2,0.8,39.8-75.1,65-45.8    C192.7,20.2,196.2,108.4,225,107.2",
    id: "XMLID_4083_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139,106.8c-7.4-8.2-14.5-2.9-15.8-1.8l-6.6-7.5c4.3-3.8,18-10.6,29.8,2.6L139,106.8    L139,106.8z",
    id: "XMLID_4082_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.1,86.2c-12.5-12.1-28.9-3-29.1-2.9l-4.9-8.7c8-4.5,26.8-9.3,41,4.4L146.1,86.2    L146.1,86.2z",
    id: "XMLID_4081_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.6,92.4c-12.3-12-28.4-3.3-29.1-2.9l-4.9-8.7c8-4.5,26.8-9.3,41,4.4L203.6,92.4    L203.6,92.4z",
    id: "XMLID_4080_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.4,155.1c-11.4,0-20.8-5.6-25.3-9.9l6.9-7.2c0.6,0.6,14.5,13.4,31.9,3.3l5,8.7    C168.5,153.7,162.2,155.1,156.4,155.1",
    id: "XMLID_4079_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M392.6,201.2l-2.5-23.1L347,189.4l2.6,19c7.3,2.4,15.1,3.6,23,3.6    C377.5,212,385,207.6,392.6,201.2",
    id: "XMLID_4078_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M418.6,94l-4.3,47.6c-1.6,17.8-34.2,50.4-47.7,50.4c-27,0-52.6-14.5-63-39L287,107.2    C298,94,342,30,370,34.5C378,56.1,403,92,418.6,94",
    id: "XMLID_4077_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M439.9,111.7c-4.8,12-11.4,13.5-24.2,13.8l2.9-31.6c0,0,4.5-9,14.1-7.8    C442.3,87.4,444.7,99.7,439.9,111.7",
    id: "XMLID_4076_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.7,93.7l-7.2-7c13.8-14.2,32.7-9.9,40.8-5.7l-4.6,8.9C393,89.5,376.6,81.3,364.7,93.7",
    id: "XMLID_4075_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.4,101.1l-7.4-6.7c14.5-16,36.8-6,37.8-5.6l-4.2,9.1C333,97.6,317,90.6,307.4,101.1",
    id: "XMLID_4074_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M356.1,162.4c-4.9,0-10.2-1.2-15.6-4.3l5-8.7c13.7,7.9,24.6-2.2,25.1-2.6l6.9,7.2    C373.7,157.6,365.7,162.4,356.1,162.4",
    id: "XMLID_4073_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.6,113.3c-7.4-7.9-14.9-3.2-16.3-2.2l-5.9-8c5.4-4,18.4-8.4,29.5,3.4L194.6,113.3    L194.6,113.3z",
    id: "XMLID_4072_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372.4,114l-7.6-6.5c9.6-11.4,21-8.7,27-5.4l1.7-0.8l4.2,9.1l-4.2,1.9    c-1.7,0.8-3.8,0.5-5.3-0.7C386.8,110.6,379.5,105.5,372.4,114",
    id: "XMLID_4071_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.3,123.9c-0.6,0-1.2-0.1-1.7-0.3l-5.4-2l3.5-9.4l2.4,0.9c10-9.1,21.8-5.4,27-1.8    l-5.7,8.2l2.8-4.1l-2.8,4.1c-1.5-1-9.3-5.6-16.2,2.6C316.1,123.3,314.7,123.9,313.3,123.9",
    id: "XMLID_4070_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M273.4,389l-1.5,20.1c12.9,15,43.7,28.6,48.6,43.3c4.8,14.7,6.5,54.6,6.5,54.6H179.7    c0,0,0-41.3,5.4-56c5.4-14.7,37.3-19.5,55-41.9l-1.5-20.1H273.4L273.4,389z",
    id: "XMLID_4069_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M284.8,420.5c-0.8,1.2-10.1,15-29,15c-18.8,0-26-14.4-26.6-15.7c3.9-3.1,7.6-6.6,10.9-10.7    l-1.5-20.1h34.9l-1.5,20.1C275.3,413,279.8,416.8,284.8,420.5",
    id: "XMLID_4068_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M255.8,440.5c-22.7,0-30.9-18-31.2-18.8l9.1-4l-4.6,2l4.6-2.1c0.2,0.5,6.1,12.9,22.1,12.9    c16.5,0,24.5-12.2,24.8-12.7l8.5,5.3C288.7,423.8,278,440.5,255.8,440.5",
    id: "XMLID_4067_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M199.7,455.6l20.3-10.1l6.4-23.7c0,0-5.2-14-10.7-13.5c-5.5,0.5-22.7,8.8-24.2,21.8    C190,443,199.7,455.6,199.7,455.6",
    id: "XMLID_4066_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M472,245.1c23.6,20.6-29.7,158.3-29.7,158.3L327,430.3c0,0-7.6,5.9-13.3,12.2    c-5.7,6.2-14.4,13.1-14.4,13.1l-14.4-12.1c0,0-4.6-26.8,4.5-36.2c3.6-3.8,31.1-3.8,31.1-3.8l91.9-39.2c0,0,8-78,14-98.7    C432.3,245,453,228.6,472,245.1",
    id: "XMLID_4065_"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    id: "XMLID_4064_",
    points: "144.9,249.6 134.7,264.2 139,430.3 108.7,467.7 93.4,432 124,262.5 120,248.7     137,234.8 144.9,249.6   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    id: "XMLID_4063_",
    points: "124,262.5 134.7,264.2 135.1,280.9 120.9,279.6 124,262.5   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M313.6,340.2H325c8.4,0,15.2-6.8,15.2-15.2c0-8.4-6.8-15.2-15.2-15.2h-4.6L313.6,340.2    L313.6,340.2z",
    id: "XMLID_4062_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M198.3,340.2H187c-8.4,0-15.2-6.8-15.2-15.2c0-8.4,6.8-15.2,15.2-15.2h4.6L198.3,340.2    L198.3,340.2z",
    id: "XMLID_4061_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M320.5,309.9c0,0-2.3,40.5-16.3,58.2C289.9,386,256,394.9,256,394.9s-33.9-8.9-48.2-26.8    c-14-17.6-16.3-58.2-16.3-58.2s15.4-26.9,18.2-44.9c0,0,18.3-10.5,46.3-10.5c28,0,48,12.5,48,12.5S305.3,305.5,320.5,309.9",
    id: "XMLID_4060_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,361c-12.7,0-20.1-9.5-21.5-11.4l8.1-6c0.5,0.7,5.5,7.1,13.6,7    c7.9-0.1,12.7-6.4,13.2-7.1l8.1,6.1c-1.3,1.8-8.7,10.4-21.2,11.4H256L256,361z",
    id: "XMLID_4059_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.3,301.3l-5.1-8.8c4.1-2.4,10.7-5.5,19.2-5.5h0.2c8.4,0,15,3.1,19,5.5l-5.1,8.7    c-2.9-1.7-7.8-3.8-14-3.8C220.2,297.3,215.3,299.5,212.3,301.3",
    id: "XMLID_4058_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M299.7,301.1c-3-1.8-7.9-4.1-14.1-4.1h-0.2c-6.2,0-11,2.3-14,4.1l-5.1-8.7    c4-2.4,10.6-5.4,19-5.4h0.2c8.5,0,15.2,3,19.2,5.4L299.7,301.1L299.7,301.1z",
    id: "XMLID_4057_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.4,319c-0.8-0.3-1.6-0.7-2.6-1.2c-2.3-1.2-5.4-2.9-9.3-2.9c-3.7,0-7.5,1.3-10.8,3.6    l-5.8-8.2c5-3.5,10.7-5.4,16.5-5.5c6.5,0,11.5,2.6,14.1,4c0.4,0.2,1.1,0.6,1.3,0.7L238.4,319L238.4,319z",
    id: "XMLID_4056_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.6,319l-3.4-9.4c0.2-0.1,0.8-0.3,1.3-0.6c2.6-1.4,7.5-4,14-4h0.2    c5.8,0,11.5,1.9,16.5,5.4l-5.8,8.2c-3.4-2.4-7.1-3.6-10.8-3.6h-0.1c-3.9,0-7,1.6-9.2,2.8C275.3,318.3,274.5,318.7,273.6,319",
    id: "XMLID_4055_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4994_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_449_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M163.7,191.7c-0.2,0-0.4,0-0.5,0l-28.9-3.2c-0.9-0.1-1.7-0.4-2.5-1l-35.8-26.7     c-1.1-0.8-1.9-2.1-2-3.6l-2.6-28.6C80.2,129,71.2,122.2,66,109c-4-10-2.3-16.5-0.2-20.1c1.8-3,5.5-6.8,12.9-7.8     c10.4-1.3,17,6,19.2,10.5c0.3,0.6,0.5,1.2,0.5,1.8l5.5,60.6l32.9,24.6l26.3,2.9l34.6-13.6l22.7-62.5c0.2-0.6,0.6-1.2,1.1-1.7     c0.3-0.3,7.9-8.1,19.9-5.8c4.3,0.8,7.6,3.4,9.4,7.2c3.4,7.4,0.2,17.8-3.6,24.4c-5.8,10.2-18,15.5-29.8,13.6l-11,30.4     c-0.5,1.3-1.5,2.4-2.9,2.9l-37.9,14.9C165,191.6,164.4,191.7,163.7,191.7z M220.8,133.5c7.1,0.4,14.2-3,17.6-8.9     c3.2-5.6,4.6-12.2,3.2-15.2c-0.3-0.8-0.8-1.3-2.2-1.6c-5.1-1-8.7,1.2-10.1,2.3L220.8,133.5z M81,91c-0.4,0-0.7,0-1.1,0.1     c-2.7,0.3-4.5,1.3-5.5,2.9c-1.4,2.4-1.1,6.5,0.8,11.3c4.5,11.2,10.9,13.3,15.4,13.4l-2.1-23.2C87.6,94.1,85.1,91,81,91z",
    id: "XMLID_3426_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_90_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M224.4,112.2c-15.5,0-24-18.2-32.1-35.8c-5.8-12.5-12.4-26.7-19.8-28.5     c-3-0.7-6.6,0.7-10.9,4.2c-2.1,1.7-5.2,1.4-6.9-0.6c-2.1-2.4-5.1-5.2-7.7-5c-5.2,0.4-11.6,11-17.2,20.4     C120.6,81.9,110.3,99,93.9,99c-0.2,0-0.4,0-0.6,0l0.2-10c0.1,0,0.2,0,0.3,0c10.8,0,19.6-14.5,27.3-27.3     c7.6-12.5,14.7-24.3,24.9-25.2c4.4-0.4,8.7,1.3,12.9,5.1c5.4-3.5,10.7-4.6,15.8-3.5c12.2,2.8,19.2,18,26.6,34     c6.9,15,14.1,30.4,23.5,30l0.4,10C225,112.2,224.7,112.2,224.4,112.2z",
    id: "XMLID_3425_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_465_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M229.3,109.7l-8.6-5.1c0.1-0.2,11.4-19.2,22-39.3c2.9-5.5,2.8-11.3-0.1-17.7     c-6.8-14.8-27.7-28.9-42.2-32.3c-18.7-4.4-31.8,5.3-31.9,5.4c-2,1.5-4.8,1.3-6.6-0.5c-0.4-0.4-10.9-10.3-33.9-10.3     C103.9,10,84.5,26.8,84,48.3c-0.4,17.4,13.7,42.9,13.8,43.2L89,96.4C88.4,95.3,73.5,68.2,74,48.1c0.3-13.3,6.3-25.6,16.9-34.6     C101,4.8,114.3,0,128.1,0c20.1,0,32.4,6.7,37.8,10.6c6-3.4,19.5-9.1,36.9-5.1c17.1,4,40.9,20.2,49,37.9     c4.2,9.2,4.1,18.4-0.1,26.5C240.9,90.3,229.5,109.5,229.3,109.7z",
    id: "XMLID_3424_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_467_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M139,106.8c-7.4-8.2-14.5-2.9-15.8-1.8l-6.6-7.5c4.3-3.8,18-10.6,29.8,2.6L139,106.8z",
    id: "XMLID_3423_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_469_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M146.1,86.2c-12.5-12.1-28.9-3-29.1-2.9l-4.9-8.7c8-4.5,26.8-9.3,41,4.4L146.1,86.2z",
    id: "XMLID_3422_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_470_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M203.6,92.4c-12.3-12-28.4-3.3-29.1-2.9l-4.9-8.7c8-4.5,26.8-9.3,41,4.4L203.6,92.4z",
    id: "XMLID_3420_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_471_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M156.5,155.1c-11.4,0-20.8-5.6-25.3-9.9l6.9-7.2c0.6,0.6,14.5,13.4,31.9,3.3l5,8.7     C168.5,153.7,162.2,155.1,156.5,155.1z",
    id: "XMLID_3419_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_478_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M366.6,197c-30.2,0-56.8-16.5-67.6-42.1c0-0.1-0.1-0.2-0.1-0.3l-16.6-45.8     c-0.6-1.7-0.3-3.5,0.9-4.9c1.5-1.8,3.7-4.7,6.5-8.3c28.2-36.6,57.5-69.9,81.1-66.1c1.8,0.3,3.3,1.5,3.9,3.2     c7.6,20.6,28.9,50.1,41.7,55.5c3.3-4,9-8,16.9-7c4.8,0.6,8.7,3.2,11.2,7.4c3.7,6.4,3.8,15.7,0,25c-5.4,13.4-13.5,16.1-24.3,16.8     l-1.1,11.7C417.5,161.6,383.5,197,366.6,197z M308.2,151.1c9.3,21.8,32.2,35.9,58.4,35.9c4.1,0,13.9-5.8,24.7-17     c10.3-10.7,17.4-22,18-28.9l4-43.5c-17.5-7-38.6-38.9-46.7-58.4c-21.3,0.7-55.7,45.2-68.9,62.5c-1.9,2.5-3.6,4.7-5,6.4     L308.2,151.1z M423.5,95.5l-2.2,24.7c8.1-0.7,11.1-2.9,14.1-10.4c2.5-6.2,2.7-12.6,0.6-16.2c-0.9-1.5-2.1-2.3-3.8-2.5     C427.3,90.5,424.5,94,423.5,95.5z",
    id: "XMLID_3413_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_464_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M356.1,162.4c-4.9,0-10.2-1.2-15.6-4.3l5-8.7c13.7,7.9,24.6-2.2,25.1-2.6l6.9,7.2     C373.7,157.6,365.7,162.4,356.1,162.4z",
    id: "XMLID_3412_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2312_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M489.3,298.5l-6.6-7.5c0.2-0.2,19.4-18.2,19.4-63.5c0-26.1-12.7-51.4-25-75.9     c-9.9-19.7-19.3-38.4-21.6-56.6c-5.2-39.6-20.8-85-96.9-85c-75.4,0-83.5,68-83.5,97.2c0,22.9,4.9,46.1,9.2,66.7     c0.8,3.8,1.6,7.5,2.3,11.1l-9.8,2c-0.7-3.5-1.5-7.2-2.3-11c-4.4-21-9.4-44.8-9.4-68.7c0-14.9,2.2-43.4,16.8-67.5     C297.8,13.4,323.6,0,358.5,0C396,0,424,10.8,441.8,32.1c16.4,19.6,21.3,44.5,23.5,61.6c2.2,16.5,11.1,34.4,20.6,53.4     c12.8,25.5,26.1,52,26.1,80.4C512,277.7,490.2,297.6,489.3,298.5z",
    id: "XMLID_3408_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_475_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M194.6,113.3c-7.4-7.9-14.9-3.2-16.3-2.2l-5.9-8c5.4-4,18.4-8.4,29.5,3.4L194.6,113.3z",
    id: "XMLID_3406_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_477_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M372.4,114l-7.6-6.5c9.6-11.4,21-8.7,27-5.4l1.7-0.8l4.2,9.1l-4.2,1.9     c-1.7,0.8-3.8,0.5-5.3-0.7C386.8,110.6,379.5,105.5,372.4,114z",
    id: "XMLID_3405_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_468_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M313.3,123.9c-0.6,0-1.2-0.1-1.7-0.3l-5.4-2l3.5-9.4l2.4,0.9c10-9.1,21.8-5.4,27-1.8     l-5.7,8.2l2.8-4.1l-2.8,4.1c-1.5-1-9.3-5.6-16.2,2.6C316.1,123.3,314.7,123.9,313.3,123.9z",
    id: "XMLID_3404_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_785_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M325,345.2h-11.4v-10H325c5.6,0,10.2-4.6,10.2-10.2s-4.6-10.2-10.2-10.2h-4.6v-10h4.6     c11.1,0,20.2,9,20.2,20.2S336.2,345.2,325,345.2z",
    id: "XMLID_3403_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_784_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M198.3,345.2H187c-11.1,0-20.2-9-20.2-20.2s9-20.2,20.2-20.2h4.6v10H187     c-5.6,0-10.2,4.6-10.2,10.2s4.6,10.2,10.2,10.2h11.4V345.2z",
    id: "XMLID_3402_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_783_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M256,361c-12.7,0-20.1-9.5-21.5-11.4l8.1-6c0.5,0.7,5.5,7.1,13.6,7     c7.9-0.1,12.7-6.4,13.2-7.1l8.1,6.1c-1.3,1.8-8.7,10.4-21.2,11.4C256.2,361,256.1,361,256,361z",
    id: "XMLID_3401_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_782_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M212.3,301.3l-5.1-8.8c4.1-2.4,10.7-5.5,19.2-5.5c0.1,0,0.2,0,0.2,0c8.4,0,15,3.1,19,5.5     l-5.1,8.7c-3-1.7-7.8-3.8-14-3.8C220.2,297.3,215.3,299.5,212.3,301.3z",
    id: "XMLID_3400_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_780_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M299.7,301.1c-3-1.8-7.9-4.1-14.1-4.1c-0.1,0-0.1,0-0.2,0c-6.2,0-11,2.3-14,4.1l-5.1-8.7     c4-2.4,10.6-5.4,19-5.4c0.1,0,0.2,0,0.2,0c8.5,0,15.2,3,19.2,5.4L299.7,301.1z",
    id: "XMLID_3399_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_761_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M238.4,319c-0.8-0.3-1.6-0.7-2.6-1.2c-2.3-1.2-5.4-2.9-9.3-2.9c-3.7,0-7.5,1.3-10.8,3.6     l-5.8-8.2c5-3.5,10.7-5.4,16.5-5.5c6.5,0,11.5,2.6,14.1,4c0.4,0.2,1.1,0.6,1.3,0.7L238.4,319z",
    id: "XMLID_3398_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_744_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M273.6,319l-3.4-9.4c0.2-0.1,0.8-0.3,1.3-0.6c2.6-1.4,7.5-4,14-4c0.1,0,0.1,0,0.2,0     c5.8,0,11.5,1.9,16.5,5.4l-5.8,8.2c-3.4-2.4-7.1-3.6-10.8-3.6c0,0-0.1,0-0.1,0c-3.9,0-7,1.6-9.2,2.8     C275.3,318.3,274.5,318.7,273.6,319z",
    id: "XMLID_3397_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_739_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M256,399.9c-0.4,0-0.8-0.1-1.3-0.2c-1.5-0.4-35.7-9.5-50.8-28.5     c-14.8-18.7-17.3-59.3-17.4-61c-0.1-1,0.2-1.9,0.7-2.8c0.1-0.3,15-26.3,17.6-43.2c0.2-1.5,1.1-2.8,2.5-3.6     c0.8-0.5,19.8-11.2,48.8-11.2c29.1,0,49.8,12.7,50.6,13.3c1.4,0.9,2.3,2.4,2.3,4.1c0.5,14.5,4.8,35.9,12.9,38.2     c2.2,0.6,3.7,2.8,3.6,5.1c-0.1,1.7-2.6,42.3-17.4,61c-15.1,19-49.4,28.2-50.8,28.5C256.8,399.8,256.4,399.9,256,399.9z      M196.6,311c0.6,7.2,3.7,39.5,15.1,53.9c11.6,14.6,38.2,23,44.3,24.7c6.1-1.8,32.7-10.2,44.3-24.7c10.6-13.4,14.1-42.1,14.9-52     c-6.2-3.8-10.8-12.2-13.6-25.1c-1.6-7.2-2.2-14.1-2.5-17.8c-5.7-3-22.2-10.5-43.2-10.5c-21.2,0-36.5,6.3-41.8,8.8     C210.9,284.6,199.7,305.5,196.6,311z",
    id: "XMLID_3394_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_740_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M334,310.8l-10-0.8l4-48.4c0.1-0.8,0.3-1.6,0.8-2.3c3.5-5.6,6.4-12.4,6.1-14.6     c-1.5-1.9-9.4-5.4-17-7.5c-1.4-0.4-2.6-1.4-3.2-2.8c-0.6-1.4-0.6-2.9,0.1-4.3c3.4-6.7,4.9-14.8,3-16c-2.2-1.5-11.6,3.1-19,9.2     c-1.1,0.9-2.5,1.3-3.9,1.1c-1.4-0.2-2.6-1-3.4-2.2c-5.6-8.3-12.7-16.4-15.9-18c-2.7,2.8-6.5,11.2-8.7,18.2     c-0.4,1.4-1.4,2.5-2.7,3.1c-1.3,0.6-2.8,0.6-4.1,0c-18-8-36.3-13.8-42.2-13.4c0.4,9.7,4.6,17.4,4.6,17.5c0.9,1.7,0.8,3.7-0.3,5.3     s-3,2.3-4.9,2c-18-2.9-36.8-3.1-40.4-0.5c0.2,7.6,6.1,17.9,8.3,21.2c0.5,0.8,0.8,1.7,0.9,2.6l2,49.9l-10,0.4l-1.9-48.6     c-2.4-3.8-9.3-15.7-9.3-26.1c0-2.7,1.2-5.1,3.3-6.9c7.1-6,27.3-4.8,40.1-3.2c-1.3-4.2-2.4-9.5-2.4-15.3c0-2.7,1.3-5.2,3.6-6.6     c3.4-2.2,9.8-3.5,31.3,4.1c6.4,2.2,12.4,4.7,16.5,6.3c2.3-6.2,6.5-15.5,11.6-19c7.4-4.9,16.4,5.5,19.8,9.4     c2.3,2.7,4.4,5.4,6.1,7.6c7-5,18.9-11.7,26.7-6.5c7.8,5.2,5.3,16.5,2.7,23.4c7.5,2.5,16.3,6.6,18.3,12c2.3,6.5-3.2,17.1-6.4,22.3     L334,310.8z",
    id: "XMLID_3393_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2313_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M281.3,424c-5.9-4.5-10.1-8.2-13.1-11.8c-0.9-1-1.3-2.3-1.2-3.6l1.5-20.3l10,0.7     l-1.4,18.1c2.5,2.6,5.8,5.5,10.2,8.8L281.3,424z",
    id: "XMLID_3391_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_743_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M327,512H179.7c-1.3,0-2.6-0.5-3.5-1.5c-0.9-0.9-1.5-2.2-1.5-3.5c0-1.7,0.1-42.4,5.7-57.7     c1.5-4.2,4.5-7.8,9.4-11.4l6,8c-3.2,2.4-5.2,4.6-6,6.9c-3.7,10-4.8,35.5-5.1,49.3h137c-0.6-11.2-2.5-37.3-6-48.1     c-0.8-2.3-2.7-5-5.7-8l7-7.1c4.2,4.2,6.9,8.1,8.2,12c5,15.1,6.7,54.4,6.8,56c0.1,1.4-0.4,2.7-1.4,3.7     C329.7,511.4,328.4,512,327,512z",
    id: "XMLID_3390_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2311_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M229.3,425.9l-5.8-8.1c4.6-3.3,8.4-6.7,11.5-10.4l-1.4-18.3l10-0.7l1.5,20.3     c0.1,1.3-0.3,2.5-1.1,3.5C240.1,417.1,235.3,421.6,229.3,425.9z",
    id: "XMLID_3388_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_742_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M255.8,440.5c-22.7,0-30.9-18-31.2-18.8l9.1-4l-4.6,2l4.6-2.1c0.2,0.5,6.1,12.9,22.1,12.9     c16.5,0,24.5-12.2,24.8-12.7l8.5,5.3C288.7,423.8,278,440.5,255.8,440.5z",
    id: "XMLID_3387_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_85_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M327.2,239.7l-1.9-9.8c8.8-1.7,16.7-7.4,20.1-14.6l-3.5-25.2l9.9-1.4l3.7,26.6     c0.1,0.9,0,1.7-0.3,2.6C350.9,228.7,339.9,237.3,327.2,239.7z",
    id: "XMLID_3386_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_787_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M486.2,512H327v-10h151.3c-5.9-13.9-16.7-45.6-11.3-80.8c0.8-5.2,1.8-11.2,2.9-17.5     c8.1-47.9,21.5-128-1.7-155.4c-8.8-10.3-19-12.1-31.9-14.5c-13.8-2.5-29.5-5.3-45.9-19.7c-0.9-0.8-1.5-2-1.7-3.2l-3.6-32.4     l9.9-1.1l3.3,30.4c13.8,11.4,26.9,13.8,39.7,16.1c13.7,2.5,26.7,4.8,37.7,17.8c26.3,30.9,12.9,110.7,4,163.5     c-1.1,6.3-2.1,12.2-2.9,17.4c-6.7,42.7,13.4,81.5,13.6,81.9c0.8,1.5,0.8,3.4-0.1,4.9C489.5,511.1,487.9,512,486.2,512z",
    id: "XMLID_3385_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_708_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M33.7,471.5l-12-20.8c-0.9-1.6-0.9-3.6,0.1-5.1l9.4-15.1l14-138.3l9.9,1L41.1,432.6     c-0.1,0.8-0.3,1.5-0.7,2.1l-8.5,13.5l10.5,18.2L33.7,471.5z",
    id: "XMLID_3384_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_786_"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    height: 10,
    id: "XMLID_3383_",
    width: 122,
    x: 38,
    y: 502
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_831_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M199.8,460.6c-1.5,0-3-0.7-4-1.9c-0.4-0.6-11-14.3-9.2-29.2c1.8-15.7,21-25.4,28.7-26.2     c8.4-0.8,13.9,11.5,15.8,16.8c0.4,1,0.4,2,0.1,3l-6.4,23.7c-0.4,1.4-1.3,2.5-2.6,3.2L202,460     C201.3,460.4,200.5,460.6,199.8,460.6z M215.8,413.3c-4.4,0.8-18.2,7.6-19.3,17.3c-0.8,7.1,2.6,14.4,5,18.5l14.3-7.1l5.4-20     C219.5,418.1,217.1,414.2,215.8,413.3z",
    id: "XMLID_3380_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_832_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M299.2,460.6c-1.1,0-2.3-0.4-3.2-1.2l-14.4-12.1c-0.9-0.8-1.5-1.8-1.7-3     c-0.5-3-4.7-29.6,5.8-40.5c3.3-3.4,14.7-5.3,33.7-5.4l88.2-37.6c1.5-14.6,8.4-77.8,13.9-96.6c4.2-14.6,14.6-26.3,26.5-29.8     c6.6-1.9,16.7-2.3,27.2,6.9l0,0c6.8,5.9,9.1,18.2,7,37.7c-1.5,14.3-5.4,32.5-11.5,54.3c-10.3,36.8-23.7,71.6-23.9,71.9     c-0.6,1.5-1.9,2.7-3.5,3.1l-114.2,26.5c-2.1,1.7-7.6,6.3-11.9,10.9c-5.9,6.5-14.6,13.4-15,13.7     C301.4,460.2,300.3,460.6,299.2,460.6z M289.5,440.9l9.8,8.2c2.9-2.5,7.4-6.4,10.7-10c5.9-6.5,13.6-12.5,14-12.8     c0.6-0.4,1.2-0.8,1.9-0.9l112.7-26.2c3.2-8.5,14-37.8,22.6-68.6c17.9-64,11.2-78.5,7.5-81.7l0,0c-5.8-5-11.8-6.6-17.9-4.8     c-8.5,2.5-16.5,11.8-19.7,23c-5.8,20-13.7,97-13.8,97.8c-0.2,1.8-1.3,3.4-3,4.1l-91.9,39.2c-0.6,0.3-1.3,0.4-1.9,0.4     c-11.1,0-24.8,1.1-27.8,2.5C288,416.4,288.2,431.4,289.5,440.9z",
    id: "XMLID_3376_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_833_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M364.6,317.2c-1.2,0-2.4-0.5-3.4-1.3c-1.1-1-26.2-24.3-33.1-52.7l9.7-2.4     c4.4,17.8,17.3,33.9,24.7,42.1c13.8-36.5,45.2-81.1,46.6-83.2l8.2,5.8c-0.4,0.5-36.6,52-47.9,88.2c-0.5,1.6-1.8,2.9-3.5,3.3     C365.5,317.1,365.1,317.2,364.6,317.2z",
    id: "XMLID_3375_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1772_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M182.7,232.8l-14.1-17.7c-0.9-1.1-1.3-2.5-1-3.9l4.8-30.6l9.9,1.5l-4.4,28.5l12.8,15.9     L182.7,232.8z",
    id: "XMLID_2998_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_756_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M38,512H5c-1.3,0-2.6-0.5-3.6-1.5C0.5,509.6,0,508.3,0,507c0.1-8.4,1.9-204.9,17.6-242.9     c12-29,66.6-42.5,74-44.2l22.3-12.5l5-33.1l9.9,1.5l-5.4,35.5c-0.2,1.5-1.2,2.9-2.5,3.6l-25,14c-0.4,0.2-0.9,0.4-1.4,0.5     c-0.6,0.1-57,12.8-67.6,38.5C13.2,300.8,10.5,470.4,10.1,502H33v-33c0-2.8,2.2-5,5-5h143v10H43v33C43,509.8,40.8,512,38,512z",
    id: "XMLID_2997_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_768_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M150.5,265c-0.4,0-0.8-0.1-1.2-0.2c-1.4-0.3-2.5-1.3-3.2-2.5l-10.6-19.9l-19.3,15.9     c-1.1,0.9-2.5,1.3-3.9,1.1c-1.4-0.2-2.7-1-3.4-2.2l-19.6-30c-0.8-1.2-1-2.6-0.7-3.9c0.3-1.3,1.2-2.5,2.4-3.2l25-14     c2.2-1.2,4.9-0.7,6.4,1.3l15.8,20.6l31.6-20.3c2.1-1.4,5-0.9,6.6,1.1l14.4,17.7l-7.8,6.3l-11.5-14.2l-27.8,17.9l8.8,16.4     l18.4-11.9l5.4,8.4l-23,14.9C152.4,264.7,151.5,265,150.5,265z M100.5,226.3l13.6,20.8l16-13.1l-13-17L100.5,226.3z",
    id: "XMLID_2993_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_712_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M108.7,472.7c-0.2,0-0.5,0-0.7,0c-1.7-0.2-3.2-1.4-3.9-3L88.8,434     c-0.4-0.9-0.5-1.9-0.3-2.9l30.4-168.3l-3.6-12.7l9.6-2.8l4,13.8c0.2,0.7,0.3,1.5,0.1,2.3l-30.3,168l11.4,26.7l23.9-29.5     l-4.3-164.2c0-1.1,0.3-2.1,0.9-3l10.2-14.7l8.2,5.7l-9.3,13.3l4.3,164.4c0,1.2-0.4,2.4-1.1,3.3l-30.3,37.4     C111.6,472,110.2,472.7,108.7,472.7z",
    id: "XMLID_2992_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_845_"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    height: 10,
    id: "XMLID_2991_",
    transform: "matrix(0.1049 0.9945 -0.9945 0.1049 656.8669 45.3895)",
    width: 33.2,
    x: 286.6,
    y: 382.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_472_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M364.7,93.7l-7.2-7c13.8-14.2,32.7-9.9,40.8-5.7l-4.6,8.9C393,89.5,376.6,81.3,364.7,93.7     z",
    id: "XMLID_2990_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_466_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M307.4,101.1l-7.4-6.7c14.5-16,36.8-6,37.8-5.6l-4.2,9.1C333,97.6,317,90.6,307.4,101.1z",
    id: "XMLID_2989_"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFamily);
export default __webpack_public_path__ + "static/media/icon-family.d3fd119ccdff7dcc08df2feb7d03dce3.svg";
export { ForwardRef as ReactComponent };